<template>
  <base-modal
    modal-content-class="login"
    :overlay-id="'modalOverlay'">
    <div class="content">
      <img src="/static/images/info.svg" alt="info">
      <p>{{ getTranslations.home_login_modal_text1 }}</p>
      <p>{{ getTranslations.home_login_modal_text2 }}
        <router-link class="text_links login" :to="'forgotPassword1'">
        {{ getTranslations.home_login_modal_text3 }}
        </router-link>
      </p>
    </div>
  </base-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { openModal, closeModal } from '../../../common/jQuery';
import BaseModal from "../../common/modal/BaseModal";
import translationMixin from "../../../common/mixins/translation";

export default {
  name: 'login-modal',
  mixins: [
    translationMixin
  ],
  components: {BaseModal},
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ])
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/LoginModal.vue